import * as React from 'react';
import { Head } from '@inertiajs/react';

interface SEOBlockProps {
  appUrl: string;
}

export function SEOBlock({ appUrl }: SEOBlockProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    name: 'Abasto Virtual',
    description: 'Delivery de frutas y verduras frescas a barrios privados y countries de Córdoba. Selección diaria del Mercado de Abasto, entrega programada en tu barrio.',
    url: `${appUrl}/barrios-privados`,
    telephone: '+5493512026384',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Córdoba',
      addressRegion: 'Córdoba',
      addressCountry: 'AR',
    },
    areaServed: {
      '@type': 'City',
      name: 'Córdoba',
    },
    priceRange: '$$',
  };

  return (
    <>
      <Head>
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Head>
      <section className="bp-seo">
        <style>{`
          .bp-seo {
            padding: 48px 24px;
            background: #fafaf7;
            border-top: 1px solid #eee;
          }
          .bp-seo-inner {
            max-width: 720px;
            margin: 0 auto;
          }
          .bp-seo h2 {
            font-size: 20px;
            font-weight: 700;
            color: #666;
            margin: 0 0 12px;
          }
          .bp-seo p {
            font-size: 15px;
            color: #888;
            line-height: 1.7;
            margin: 0;
          }
        `}</style>
        <div className="bp-seo-inner">
          <h2>Frutas y verduras frescas en barrios privados de Córdoba</h2>
          <p>
            Abasto Virtual realiza entregas de frutas y verduras frescas en countries, barrios cerrados
            y condominios de Córdoba. Selección diaria del Mercado de Abasto, entrega programada,
            coordinación con guardias de seguridad y pedido online desde el celular.
          </p>
        </div>
      </section>
    </>
  );
}
